import { render, staticRenderFns } from "./verhuizen-naar.vue?vue&type=template&id=47da3456"
import script from "./verhuizen-naar.vue?vue&type=script&lang=js"
export * from "./verhuizen-naar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports